import { render, staticRenderFns } from "./NewsModal.vue?vue&type=template&id=c53635a4&scoped=true&"
import script from "./NewsModal.vue?vue&type=script&lang=js&"
export * from "./NewsModal.vue?vue&type=script&lang=js&"
import style0 from "./NewsModal.vue?vue&type=style&index=0&id=c53635a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53635a4",
  null
  
)

export default component.exports